import React from "react";
import themePropTypes from "../theme-prop-types";

/* eslint-disable react/prop-types */
const HtmlText = ({ value, params, name }) => {
  const Component = props => (
    <div
      {...props}
      className={`html-text-web-sdk ${name} ${
        params ? params.split("|").join(" ") : ""
      }`}
      data-testid={`html-text-${name}`}
    />
  );

  return (
    <>
      {typeof value === "string" || value instanceof String ? (
        <Component dangerouslySetInnerHTML={{ __html: value }} />
      ) : (
        <Component>{value}</Component>
      )}
    </>
  );
};

HtmlText.propTypes = themePropTypes.htmlText;

export default HtmlText;
